<div class="pg-wrapper page-header">
  <div class="grid align-items-center"
    ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'pt-2 pb-2' : 'pt-3 pb-3'}}">

    <div class="col-3">
      <div class="page-header__geolocation" *ngIf="(deviceValue | async) === DTypes.Desktop">
        <shared-geolocation
          *ngIf="(deviceValue | async) === DTypes.Desktop">
        </shared-geolocation>
      </div>

      <div class="page-header__mobile-menu" (click)="onMobileMenuView()"
        *ngIf="(deviceValue | async) === DTypes.Tablet || (deviceValue | async) === DTypes.Mobile">
        <div class="page-header__mobile-menu-link" id="pgLayoutMenuLink">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>

    <div class="col-6">
      <a routerLink="/" class="page-header__link">
        <div class="ui-logo__header"></div>
      </a>
    </div>

    <div class="col-3">
      <div class="page-header__user" *ngIf="(deviceValue | async) === DTypes.Desktop">
        <shared-account-header
          [Device]="DTypes.Desktop"
          *ngIf="(deviceValue | async) === DTypes.Desktop">
        </shared-account-header>
      </div>

      <div class="page-header__user pl-7"
        *ngIf="(deviceValue | async) === DTypes.Tablet || (deviceValue | async) === DTypes.Mobile">

        <div class="page-header__user-icon" (click)="onMobileProfileView()">
          <shared-account-header
            [Device]="DTypes.Mobile"
            *ngIf="(deviceValue | async) === DTypes.Tablet || (deviceValue | async) === DTypes.Mobile">
          </shared-account-header>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row" *ngIf="(deviceValue | async) === DTypes.Desktop">
  <shared-main-menu [Device]="DTypes.Desktop"></shared-main-menu>
</div>
